import { useCallback, useContext, useEffect, useLayoutEffect, useRef } from 'react';
import { registerFilter, updateFilter } from '../stateReducer/actions';
import { DataGridContext } from './context';
function useTransientRef(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
function useDataGridCustomFilter(_ref) {
  let {
    dataKey,
    label,
    includeRow,
    defaultValue,
    isActive
  } = _ref;
  const {
    filter = {},
    dispatch
  } = useContext(DataGridContext);

  /* If any of these properties are defined as closures/arrow functions,
   * it would cause the filter to be re-registered on every render. We can
   * instead save them to a ref and keep the ref in the store, and simply
   * update the value of that ref (without triggering a dispatch call or a
   * re-render).
   */
  const labelRef = useTransientRef(label);
  const includeRowRef = useTransientRef(includeRow);
  const isActiveRef = useTransientRef(isActive);
  useLayoutEffect(() => {
    dispatch(registerFilter({
      key: dataKey,
      label: labelRef,
      defaultValue,
      includeRow: includeRowRef,
      isActive: isActiveRef
    }));
  }, [dataKey, defaultValue, dispatch, labelRef, includeRowRef, isActiveRef]);
  const currentValue = filter[dataKey] ? filter[dataKey].value : defaultValue;
  const update = useCallback(value => {
    dispatch(updateFilter(dataKey, value));
  }, [dataKey, dispatch]);
  return [currentValue, update];
}
export default useDataGridCustomFilter;